import {useEffect,useRef,useState} from 'react';
/** Visual interpolation only. Pause retains the current point between observations. */
export function useRouteAnimation(index:number|undefined,playing:boolean,delayMs:number|undefined,onNext:()=>void,identity:string){
 const [fraction,setFraction]=useState(0),progress=useRef(0),key=useRef(''),next=useRef(onNext);next.current=onNext;
 useEffect(()=>{const current=`${identity}:${index}`;if(key.current!==current){key.current=current;progress.current=0;setFraction(0);}},[index,identity]);
 useEffect(()=>{if(!playing||index===undefined||!delayMs)return;let frame=0,last=0,cancelled=false;
  const tick=(time:number)=>{if(cancelled)return;if(last)progress.current=Math.min(1,progress.current+(time-last)/delayMs);last=time;setFraction(progress.current);
   if(progress.current>=1){next.current();return;}frame=requestAnimationFrame(tick);};
  frame=requestAnimationFrame(tick);return()=>{cancelled=true;cancelAnimationFrame(frame);};
 },[index,identity,playing,delayMs]);
 return key.current===`${identity}:${index}`?fraction:0;
}
